module.exports = __webpack_public_path__ + "userRegistro.png?23aebaf8def8f408b7e596cf0df4a6e0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userRegistro.png
// module id = 693
// module chunks = 0 2 7 8 9 10